<template>
  <section class="admin-tasks">
    <div class="admin-tasks__card">
      <div class="admin-tasks__header">
        <h6 class="admin-tasks__title">
          <i class="icon icon-th-list admin-tasks__title-icon" aria-hidden="true"></i>
          {{ $t('lang.label.admin_panel_tasks_section') }}
        </h6>
        <span class="admin-tasks__badge">{{
          $t('lang.label.admin_panel_tasks_progress', {
            completed: completedCount,
            total: totalCount,
          })
        }}</span>
      </div>

      <div v-if="pendingtasks.length > 0" class="admin-tasks__list">
        <label
          v-for="(task, key) in pendingtasks"
          :key="task.id || key"
          class="admin-tasks__item"
          :class="{ 'admin-tasks__item--done': donetasks[key] }"
        >
          <input
            class="admin-tasks__checkbox"
            type="checkbox"
            :disabled="$store.state.authentication.user.role_id != 1"
            v-model="donetasks[key]"
            @change="checkDone(key)"
          />
          <span class="admin-tasks__content">
            <span class="admin-tasks__label">
              {{ getTranslation(task.title) }}
              <strong v-if="getParsedMessage(task.message)">
                {{ getParsedMessage(task.message).params.bc_name }}
              </strong>
            </span>
            <span class="admin-tasks__meta">
              <i class="icon icon-calendar" aria-hidden="true"></i>
              {{ formatTaskDate(task.updated) }}
              <template v-if="ownerLabel(task)">
                · {{ ownerLabel(task) }}
              </template>
            </span>
          </span>
        </label>
      </div>

      <p v-else class="admin-tasks__empty">{{ $t('lang.label.admin_panel_tasks_empty') }}</p>
    </div>
  </section>
</template>

<script>
import moment from "moment";
//import "moment/locale/fr";
import { notificationService } from "@/_services";
import { formattersMixin } from "@/_mixins/";

export default {
  props: {
    link: Object,
    bdrName: {
      type: String,
      default: "",
    },
    fromAdminTasks: {
      type: Boolean,
      default: false,
    },
    opportunity_id: {
      type: Number,
      default: false,
    },
  },
  data() {
    return {
      pendingtasks: [],
      donetasks: [],
      cantpending: 0,
    };
  },
  mixins: [formattersMixin],
  computed: {
    totalCount() {
      return this.pendingtasks.length;
    },
    completedCount() {
      if (this.totalCount === 0) return 0;
      return this.totalCount - this.cantpending;
    },
  },
  created() {
    const currentLinkId = this.fromAdminTasks
      ? this.opportunity_id
      : this.link.link.id;
    notificationService.getTasks(currentLinkId).then((result) => {
      this.pendingtasks = result;
      for (let i = 0; i < result.length; i++) {
        if (this.pendingtasks[i].notification_status_id == "2") {
          this.donetasks[i] = true;
        } else {
          this.cantpending++;
        }
      }

      this.$emit("pendingTasks", this.cantpending);
      this.$emit("listOfTasks", this.pendingtasks);

      const currentTask = this.pendingtasks.find(
        (el) => el.notification_status_id === "1"
      );

      const listPendingTasks = this.pendingtasks.filter(
        (el) =>
          el.notification_status_id === "1" &&
          el.id != (currentTask && currentTask.id)
      );

      this.$emit("taskSelected", {
        currentTask: currentTask,
        listPendingTasks: listPendingTasks,
      });
    });
  },
  methods: {
    ownerLabel(task) {
      return this.bdrName || task.task_owner_name || "";
    },
    formatTaskDate(updated) {
      if (!updated) return "";
      const m = moment(updated);
      if (!m.isValid()) return updated;
      return m.locale("en").format("DD MMM · HH:mm");
    },
    checkDone(taskid) {
      if (!this.fromAdminTasks) {
        if (this.donetasks[taskid] == true) {
          this.pendingtasks[taskid].notification_status_id = "2";
          this.cantpending--;
          notificationService.closeTask(
            this.pendingtasks[taskid].id,
            this.cantpending,
            this.pendingtasks[taskid].ref_id
          );
        } else {
          this.pendingtasks[taskid].notification_status_id = "1";
          this.cantpending++;
          notificationService.openTask(
            this.pendingtasks[taskid].id,
            this.cantpending,
            this.pendingtasks[taskid].ref_id
          );
        }

        this.$emit("pendingTasks", this.cantpending);
      }
    },
    getParsedMessage(message) {
      try {
        const parsed = JSON.parse(message);
        if (parsed && typeof parsed === "object" && parsed.params) {
          return parsed;
        }
        return null;
      } catch (e) {
        return null;
      }
    },
  },
};
</script>

<style scoped>
.admin-tasks {
  --ol-brand: #5054eb;
  padding: 0.75rem 1rem 0.5rem;
  margin-top: 0;
}

.admin-tasks__title-icon {
  color: var(--ol-brand);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  line-height: 1;
  overflow: hidden;
  flex-shrink: 0;
}

.admin-tasks__card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  background: #ffffff;
}

.admin-tasks__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.admin-tasks__title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #6b7280;
  margin: 0;
  text-transform: uppercase;
}

.admin-tasks__badge {
  font-size: 0.7rem;
  font-weight: 600;
  color: #4b5563;
  background: #f3f4f6;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
}

.admin-tasks__list {
  max-height: 280px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.admin-tasks__list::-webkit-scrollbar {
  width: 4px;
}

.admin-tasks__list::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}

.admin-tasks__item {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  margin: 0;
  cursor: pointer;
  padding: 0.35rem 0;
}

.admin-tasks__checkbox {
  flex-shrink: 0;
  margin-top: 0.2rem;
  width: 16px;
  height: 16px;
  accent-color: #5054eb;
  cursor: pointer;
}

.admin-tasks__checkbox:disabled {
  cursor: not-allowed;
}

.admin-tasks__content {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.admin-tasks__label {
  font-size: 0.82rem;
  color: #111827;
  line-height: 1.35;
}

.admin-tasks__item--done .admin-tasks__label {
  color: #9ca3af;
  text-decoration: line-through;
}

.admin-tasks__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem;
  font-size: 0.72rem;
  color: #9ca3af;
  margin-top: 0.15rem;
}

.admin-tasks__meta i {
  font-size: 0.7rem;
}

.admin-tasks__empty {
  font-size: 0.8rem;
  color: #9ca3af;
  margin: 0;
}
</style>
